export default __webpack_public_path__ + "static/principles-of-use-do-5d5700a670841b965df837b55a9071a056a19f6472117011cf8395f39d461684.png";